// extracted by mini-css-extract-plugin
export default {"box":"OneStop_box__d3D6Z","logos":"OneStop_logos__nstdv","zeal":"OneStop_zeal__3VNLV","logos_wrapper":"OneStop_logos_wrapper__nTAam"};